import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Relation } from '@tcc-mono/vandijk/shared/data-access/models';
import { RelationService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelationRepository extends CoreRepository<Relation> {

  public relations$: Observable<Relation[]> = this.entities$;
  public selectedRelation$: Observable<Relation> = this.activeEntity$;

  public constructor(
    protected readonly _relationService: RelationService
  ) {
    super(
      { name: 'relations' },
      _relationService
    )
  }

  public selectRelation = (id: number): Observable<Relation> => {
    return this.selectEntity(id);
  }

  public addRelation = (relation: Partial<Relation>): Observable<Relation> => {
    return this.addEntity(relation);
  }

  public updateRelation = (relationId: number, relation: Relation): Observable<Relation> => {
    return this.updateEntity(relationId, relation);
  }

  public getRelation = (relationId: number, setActive: boolean = true, forceGet: boolean = false): Observable<Relation> => {
    return this.getEntity(relationId, setActive, forceGet);
  }

  public removeRelation = (relationId: number): Observable<unknown> => {
    return this.removeEntity(relationId);
  }

  public setActiveRelation = (relationId: number): void => {
    this.setActiveEntity(relationId);
  }
}
